var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0464 2.6534L7.75801 10.8652L22.0139 19.1334L22.0464 2.6534Z",
    fill: "#494949",
    fillOpacity: 0.4,
    stroke: "#7A7A7A",
    strokeWidth: 1.34783
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1738 1.54883L0.999915 10.9836L17.1738 20.4184",
    stroke: "#989898",
    strokeWidth: 0.404348
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.34783,
    cy: 1.34783,
    r: 1.34783,
    transform: "matrix(-1 0 0 1 32 9.63574)",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote_left.2537c56b874f5b6f2e5a784b7defb812.svg";
export { ForwardRef as ReactComponent };